/**
 * Service layer — the plan check submittal cover letter (api/plan-check-letter.js,
 * docs/PLAN_CHECK_PERFORMANCE.md).
 */
async function call(body) {
  const headers = { 'Content-Type': 'application/json' }
  try { if (window.__clerkGetToken) { const t = await window.__clerkGetToken(); if (t) headers['Authorization'] = 'Bearer ' + t } }
  catch (_) { /* server rejects unauthenticated */ }
  return fetch('/api/plan-check-letter', { method: 'POST', headers, body: JSON.stringify(body) })
}

/** What the agency review already knows: agency, contact, project, address, permit type, tracking no. */
export async function getPlanCheckLetterPrefill(reviewId) {
  const res = await call({ action: 'prefill', reviewId })
  const j = await res.json().catch(() => ({}))
  if (!res.ok) throw new Error(j.error || 'Could not read the agency review')
  return j
}

/** Render the letter → an object URL for the PDF. */
export async function renderPlanCheckLetter(letter) {
  const res = await call({ action: 'render', ...letter })
  if (!res.ok) { const j = await res.json().catch(() => ({})); throw new Error(j.error || 'Could not make the letter (' + res.status + ')') }
  return URL.createObjectURL(await res.blob())
}

/* ── Neighbor letters (api/_neighborLetters.js, docs/NEIGHBOR_LETTERS.md) ──────────────────────── */

/** What the review knows for a neighbor letter: agency, project, address, the agency's boards, Hub. */
export async function getNeighborLetterPrefill(reviewId) {
  const res = await call({ action: 'neighborPrefill', reviewId })
  const j = await res.json().catch(() => ({}))
  if (!res.ok) throw new Error(j.error || 'Could not read the agency review')
  return j
}

/** The letter as a PDF, for a look before it goes out → an object URL. Nothing is stored. */
export async function renderNeighborLetter(letter) {
  const res = await call({ action: 'neighborRender', ...letter })
  if (!res.ok) { const j = await res.json().catch(() => ({})); throw new Error(j.error || 'Could not make the letter (' + res.status + ')') }
  return URL.createObjectURL(await res.blob())
}

/** Store the letter and put it on the project's Client Hub (replaces the PDF on this review's card). */
export async function postNeighborLetter(reviewId, letter, userName) {
  const res = await call({ action: 'neighborPost', reviewId, userName, ...letter })
  const j = await res.json().catch(() => ({}))
  if (!res.ok) throw new Error(j.error || 'Could not put it on the Client Hub')
  return j
}
